import { addBreadcrumb } from '@sentry/nextjs';

/**
 * Logger de diagnóstico do Marfeel SDK — observe-only.
 *
 * Silencioso por padrão. Liga via `?marfeelDebug=1` (persistido em localStorage para
 * sobreviver às navegações SPA) ou diretamente por `localStorage.marfeelDebug = '1'`.
 * Como o SDK do Marfeel só roda em produção, o gate é controlado em runtime no navegador,
 * sem precisar de deploy/env.
 *
 * Saídas quando habilitado: `console.info('[marfeel]', ...)` + breadcrumb no Sentry
 * (no-op seguro quando o Sentry não está inicializado, ex.: dev).
 */

const STORAGE_KEY = 'marfeelDebug';
const QUERY_FLAG = 'marfeelDebug=1';

export function isMarfeelDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    const enabledByQuery = window.location.search.indexOf(QUERY_FLAG) > -1;

    // ligado por query param persiste, para seguir habilitado entre navegações SPA
    if (enabledByQuery) {
      window.localStorage.setItem(STORAGE_KEY, '1');
      return true;
    }

    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function logMarfeelEvent(event: string, payload: Record<string, unknown> = {}): void {
  if (!isMarfeelDebugEnabled()) return;

  try {
    const data = { ...payload, url: window.location.href, ts: Date.now() };

    // eslint-disable-next-line no-console
    console.info('[marfeel]', event, data);

    addBreadcrumb({ category: 'marfeel', level: 'info', message: event, data });
  } catch {
    // diagnóstico nunca pode quebrar a página
  }
}
